function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import React from"react";import*as R from"ramda";import{Col as AntdCol,Row as AntdRow,Space}from"antd";import styled from"@emotion/styled";import facepaint from"facepaint";import{css}from"@emotion/react";import{useIsScreenWidth}from"@wp/src/components/common/responsive/useResponsive";const Row=({className,justify,children,gutter,align,...restProps})=>React.createElement(AntdRow,_extends({justify:justify,gutter:gutter,className:className,align:align},restProps),children);const Col=({span,offset,className,children,title,...props})=>React.createElement(AntdCol,_extends({span:span,offset:offset,className:className,title:title},props),children);const PageCentered=styled.div`
  min-height: calc(var(--vh, 1vh) * 95 - 80px);
  width: 100%;
  display: flex;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
`;const FullPageView=styled.div`
  min-height: calc(var(--vh, 1vh) * 95 - 80px);
  width: 100%;
`;const breakpoints={xs:0,sm:576,md:768,lg:992,xl:1200,xxl:1600};export const sortedBreakpointsArray=Object.values(breakpoints).sort((a,b)=>a-b);const mediaQuery=facepaint(sortedBreakpointsArray.map(bp=>`@media (min-width: ${bp}px)`),{literal:true,overlap:true});const verticalBreakpoints=[0,400,500,600,700,900,1200,1600];const mediaHeightQuery=facepaint(verticalBreakpoints.map(bp=>`@media (min-height: ${bp}px)`),{literal:true,overlap:true});function isMobile(){if(typeof window!=="undefined"){return window.matchMedia("(max-width: 600px)").matches}return false}const WpSpace=Space;export const generateItemsMargin=(direction,size)=>css`
  & > :not(:last-child) {
    margin-${direction}: ${size}px;
  }
`;export const getRowSpacingStyles=itemsSpacingVertical=>{const isRowGapSupported=`@supports (row-gap: ${itemsSpacingVertical}px)`;const rowSpacingMarginFallback=generateItemsMargin("bottom",itemsSpacingVertical);return css`
    ${isRowGapSupported} {
      row-gap: ${itemsSpacingVertical}px;
    }

    @supports not (row-gap: ${itemsSpacingVertical}px) {
      ${rowSpacingMarginFallback}
    }
  `};export const getColumnSpacingStyles=itemsSpacingHorizontal=>{const isColumnGapSupported=`@supports (column-gap: ${itemsSpacingHorizontal}px)`;const columnSpacingMarginFallback=generateItemsMargin("right",itemsSpacingHorizontal);return css`
    ${isColumnGapSupported} {
      column-gap: ${itemsSpacingHorizontal}px;
    }

    @supports not (column-gap: ${itemsSpacingHorizontal}px) {
      ${columnSpacingMarginFallback}
    }
  `};const getSpacingStyles=props=>{const isFlexDisplay=R.equals(props.display,"flex")||R.isNil(props.display);let rowSpacingCss=css``;let columnSpacingCss=css``;if(typeof props.itemsSpacingVertical==="number"){rowSpacingCss=isFlexDisplay?getRowSpacingStyles(props.itemsSpacingVertical):generateItemsMargin("bottom",props.itemsSpacingVertical)}if(typeof props.itemsSpacingHorizontal==="number"){columnSpacingCss=isFlexDisplay?getColumnSpacingStyles(props.itemsSpacingHorizontal):generateItemsMargin("right",props.itemsSpacingHorizontal)}return css`
    ${rowSpacingCss}
    ${columnSpacingCss}
  `};const FlexLayout=styled.div`
  display: ${props=>props.display?`${props.display}`:"flex"};
  width: ${props=>props.occupyParentWidth?"100%":""};
  width: ${props=>props.width?props.width:""};
  height: ${props=>props.occupyParentHeight?"100%":""};
  height: ${props=>props.height?props.height:""};
  margin: ${props=>props.margin?props.margin:""};
  margin-top: ${props=>props.marginTop?`${props.marginTop}px`:""};
  margin-bottom: ${props=>props.marginBottom?`${props.marginBottom}px`:""};
  margin-left: ${props=>props.marginLeft?`${props.marginLeft}px`:""};
  margin-right: ${props=>props.marginRight?`${props.marginRight}px`:""};
  justify-content: ${props=>props.justifyContent?props.justifyContent:"center"};
  flex-direction: ${props=>props.flexDirection?props.flexDirection:"row"};
  align-items: ${props=>props.alignItems?props.alignItems:"center"};
  line-height: ${props=>props.lineHeight||props.fontSize?`${props.lineHeight||props.fontSize}px`:""};
  align-content: ${props=>props.alignContent?props.alignContent:"center"};
  flex-wrap: ${props=>props.flexWrap?props.flexWrap:"wrap"};
  max-width: ${props=>props.maxWidth?props.maxWidth:""};
  min-width: ${props=>props.minWidth?props.minWidth:""};
  min-height: ${props=>props.minHeight?props.minHeight:""};
  background-color: ${props=>props.backgroundColor?props.backgroundColor:""};
  cursor: ${props=>props.cursor?props.cursor:""};
  padding: ${props=>props.padding?props.padding:""};
  text-align: ${props=>props.textAlign?props.textAlign:""};
  color: ${props=>props.color?props.color:""};
  font-size: ${props=>props.fontSize?`${props.fontSize}px`:""};
  font-weight: ${props=>props.fontWeight?`${props.fontWeight}`:""};
  border-radius: ${props=>props.borderRadius?`${props.borderRadius}`:""};
  border: ${props=>props.border?`${props.border}`:""};
  border-bottom: ${props=>props.borderBottom?`${props.borderBottom}`:""};
  box-sizing: ${props=>props.boxSizing?`${props.boxSizing}`:""};
  flex: ${props=>props.flex?`${props.flex}`:""};
  overflow: ${props=>props.overflow?`${props.overflow}`:""};

  ${props=>getSpacingStyles(props)}

  ${props=>props.equalWidthItems?css`
          & > * {
            flex: 1 1 0;
          }
        `:""}
  ${props=>props.childrenTakeFullWidth?css`
          & > * {
            width: 100%; /* Ensures full width */
          }
        `:""}

  ${props=>props.enableLineBreak?css`
          white-space: normal;
          overflow-wrap: break-word;
          word-wrap: break-word;
        `:""}
`;const FlexFlip=props=>{const{flipToColumn,children,itemsSpacingVertical,itemsSpacingHorizontal,...flexProps}=props;const itemsSpacingVerticalValue=flipToColumn?itemsSpacingVertical:undefined;const itemsSpacingHorizontalValue=flipToColumn?undefined:itemsSpacingHorizontal;return React.createElement(FlexLayout,_extends({},flexProps,{flexDirection:flipToColumn?"column":undefined,itemsSpacingVertical:itemsSpacingVerticalValue,itemsSpacingHorizontal:itemsSpacingHorizontalValue}),children)};const FlexFlipOnScreenSize=props=>{const{children,flipAt,...flexFlipProps}=props;const{isBelow:flipToColumn}=useIsScreenWidth(breakpoints[flipAt]);return React.createElement(FlexFlip,_extends({},flexFlipProps,{flipToColumn:flipToColumn}),children)};export{FlexLayout,FlexFlip,FlexFlipOnScreenSize,Row,Col,PageCentered,FullPageView,mediaQuery,mediaHeightQuery,verticalBreakpoints,isMobile,WpSpace,breakpoints};